import { Component } from 'react'
import LoadError from './LoadError'

export default class PageErrorBoundary extends Component {
  state = { failed: false }
  static getDerivedStateFromError () { return { failed: true } }
  componentDidUpdate (previous) {
    if (previous.resetKey !== this.props.resetKey && this.state.failed) this.setState({ failed: false })
  }
  render () {
    if (this.state.failed) return <LoadError onRetry={() => window.location.reload()} onBack={this.props.onBack} />
    return this.props.children
  }
}
